module.exports = __webpack_public_path__ + "assets/img/c31.8dc86b33.png";